
    import { loadTour } from './main.js';
    window.loadTour = loadTour;

    const slides = document.querySelectorAll('.slide');
    let current = 0;

    setInterval(() => {
      slides[current].classList.remove('active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('active');
    }, 3000); // Change slide every 3 seconds

    const sections = document.querySelectorAll('section');
  const navLinks = document.querySelectorAll('nav ul li a');

  window.addEventListener('scroll', () => {
    let current = '';

    sections.forEach(section => {
      const sectionTop = section.offsetTop;
      const sectionHeight = section.clientHeight;

      if (pageYOffset >= sectionTop - sectionHeight / 3) {
        current = section.getAttribute('id');
      }
    });

    navLinks.forEach(link => {
      link.classList.remove('active');
      if (link.getAttribute('href') === `#${current}`) {
        link.classList.add('active');
      }
    });
  });

//slide

const observer = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('slide-in');
      observer.unobserve(entry.target);
    }
  });
}, {
  threshold: 0.5
});

// Observe all cards
document.querySelectorAll('.card').forEach(card => {
  observer.observe(card);
});

// Observe header
const header = document.querySelector('.virtual-tour-header');
if (header) {
  observer.observe(header);
}

// 🔥 Observe about section content
const aboutLeft = document.querySelector('.about-left');
const aboutRight = document.querySelector('.about-right');
if (aboutLeft) observer.observe(aboutLeft);
if (aboutRight) observer.observe(aboutRight);



//carousel
const swiper = new Swiper('.swiper-container', {
    slidesPerView: 3,
    centeredSlides: true,
    spaceBetween: 30,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      }
    }
  });

  

  